/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 10V16M22 10V16M10 7C10 7.27614 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.27614 9 7M10 7C10 6.72386 9.77614 6.5 9.5 6.5C9.22386 6.5 9 6.72386 9 7M10 7H9M15 7C15 7.27614 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.27614 14 7M15 7C15 6.72386 14.7761 6.5 14.5 6.5C14.2239 6.5 14 6.72386 14 7M15 7H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 19H8.2C7.07989 19 6.51984 19 6.09202 18.782C5.71569 18.5903 5.40973 18.2843 5.21799 17.908C5 17.4802 5 16.9201 5 15.8V10M9 19V22M9 19H15M15 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V10M15 19V22M5 10H19M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10M5.5 1.5L8 4M17.5 1.5L15.5 3.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V15.8C19 16.9201 19 17.4802 18.782 17.908C18.5903 18.2843 18.2843 18.5903 17.908 18.782C17.4802 19 16.9201 19 15.8 19H8.2C7.07989 19 6.51984 19 6.09202 18.782C5.71569 18.5903 5.40973 18.2843 5.21799 17.908C5 17.4802 5 16.9201 5 15.8V10Z"
				fill="currentColor"
			/>
			<path
				d="M9 19H8.2C7.07989 19 6.51984 19 6.09202 18.782C5.71569 18.5903 5.40973 18.2843 5.21799 17.908C5 17.4802 5 16.9201 5 15.8V10M9 19V22M9 19H15M15 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V10M15 19V22M5 10H19M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10M2 10V16M22 10V16M5.5 1.5L8 4M17.5 1.5L15.5 3.5M10 7C10 7.27614 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.27614 9 7M10 7C10 6.72386 9.77614 6.5 9.5 6.5C9.22386 6.5 9 6.72386 9 7M10 7H9M15 7C15 7.27614 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.27614 14 7M15 7C15 6.72386 14.7761 6.5 14.5 6.5C14.2239 6.5 14 6.72386 14 7M15 7H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.96967 0.96967C5.26256 0.676777 5.73744 0.676777 6.03033 0.96967L8.2672 3.20654C9.37442 2.59687 10.6467 2.25 12 2.25C13.0872 2.25 14.1222 2.47389 15.0613 2.87807L16.9697 0.96967C17.2626 0.676777 17.7374 0.676777 18.0303 0.96967C18.3232 1.26256 18.3232 1.73744 18.0303 2.03033L16.4244 3.63623C18.4345 5.0364 19.75 7.36458 19.75 10V10.25H4.25V10C4.25 7.62076 5.32213 5.49194 7.00963 4.07029L4.96967 2.03033C4.67678 1.73744 4.67678 1.26256 4.96967 0.96967ZM8.25 7C8.25 6.30964 8.80964 5.75 9.5 5.75C10.1904 5.75 10.75 6.30964 10.75 7C10.75 7.69036 10.1904 8.25 9.5 8.25C8.80964 8.25 8.25 7.69036 8.25 7ZM13.25 7C13.25 6.30964 13.8096 5.75 14.5 5.75C15.1904 5.75 15.75 6.30964 15.75 7C15.75 7.69036 15.1904 8.25 14.5 8.25C13.8096 8.25 13.25 7.69036 13.25 7Z"
				fill="currentColor"
			/>
			<path
				d="M4.25 11.75L4.25 15.8304C4.24999 16.3646 4.24998 16.8104 4.27974 17.1747C4.31078 17.5546 4.37789 17.9112 4.54973 18.2485C4.81338 18.7659 5.23408 19.1866 5.75153 19.4503C6.08879 19.6221 6.44545 19.6892 6.82533 19.7203C7.18956 19.75 7.6354 19.75 8.16955 19.75H8.25V22C8.25 22.4142 8.58579 22.75 9 22.75C9.41421 22.75 9.75 22.4142 9.75 22V19.75H14.25V22C14.25 22.4142 14.5858 22.75 15 22.75C15.4142 22.75 15.75 22.4142 15.75 22V19.75H15.8305C16.3646 19.75 16.8104 19.75 17.1747 19.7203C17.5546 19.6892 17.9112 19.6221 18.2485 19.4503C18.7659 19.1866 19.1866 18.7659 19.4503 18.2485C19.6221 17.9112 19.6892 17.5546 19.7203 17.1747C19.75 16.8104 19.75 16.3646 19.75 15.8305V11.75H4.25Z"
				fill="currentColor"
			/>
			<path
				d="M2 9.25C2.41421 9.25 2.75 9.58579 2.75 10V16C2.75 16.4142 2.41421 16.75 2 16.75C1.58579 16.75 1.25 16.4142 1.25 16V10C1.25 9.58579 1.58579 9.25 2 9.25Z"
				fill="currentColor"
			/>
			<path
				d="M22.75 10C22.75 9.58579 22.4142 9.25 22 9.25C21.5858 9.25 21.25 9.58579 21.25 10V16C21.25 16.4142 21.5858 16.75 22 16.75C22.4142 16.75 22.75 16.4142 22.75 16V10Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 19H8.2C7.07989 19 6.51984 19 6.09202 18.782C5.71569 18.5903 5.40973 18.2843 5.21799 17.908C5 17.4802 5 16.9201 5 15.8V10M9 19V22M9 19H15M15 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V10C19 6.13401 15.866 3 12 3C11.6605 3 11.3266 3.02417 11 3.07089M15 19V22M5 10H15.5M5 10C5 7.55552 6.25299 5.4037 8.15176 4.15176L5.5 1.5M2 10V16M22 10V16M17.5 1.5L15.5 3.5M10 7C10 7.27614 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.27614 9 7M10 7C10 6.72386 9.77614 6.5 9.5 6.5C9.22386 6.5 9 6.72386 9 7M10 7H9M15 7C15 7.27614 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.27614 14 7M15 7C15 6.72386 14.7761 6.5 14.5 6.5C14.2239 6.5 14 6.72386 14 7M15 7H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 19H8.2C7.07989 19 6.51984 19 6.09202 18.782C5.71569 18.5903 5.40973 18.2843 5.21799 17.908C5 17.4802 5 16.9201 5 15.8V10M9 19V22M9 19H15M15 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V10M15 19V22M5 10H19M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10M2 10V16M22 10V16M5.5 1.5L8 4M17.5 1.5L15.5 3.5M10 7C10 7.27614 9.77614 7.5 9.5 7.5C9.22386 7.5 9 7.27614 9 7M10 7C10 6.72386 9.77614 6.5 9.5 6.5C9.22386 6.5 9 6.72386 9 7M10 7H9M15 7C15 7.27614 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.27614 14 7M15 7C15 6.72386 14.7761 6.5 14.5 6.5C14.2239 6.5 14 6.72386 14 7M15 7H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M2 9.25C2.41421 9.25 2.75 9.58579 2.75 10V16C2.75 16.4142 2.41421 16.75 2 16.75C1.58579 16.75 1.25 16.4142 1.25 16V10C1.25 9.58579 1.58579 9.25 2 9.25Z"
					fill="currentColor"
				/>
				<path
					d="M22.75 10C22.75 9.58579 22.4142 9.25 22 9.25C21.5858 9.25 21.25 9.58579 21.25 10V16C21.25 16.4142 21.5858 16.75 22 16.75C22.4142 16.75 22.75 16.4142 22.75 16V10Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.96967 0.96967C5.26256 0.676777 5.73744 0.676777 6.03033 0.96967L8.2672 3.20654C9.37442 2.59687 10.6467 2.25 12 2.25C13.0872 2.25 14.1222 2.47389 15.0613 2.87807L16.9697 0.96967C17.2626 0.676777 17.7374 0.676777 18.0303 0.96967C18.3232 1.26256 18.3232 1.73744 18.0303 2.03033L16.4244 3.63623C18.4345 5.0364 19.75 7.36458 19.75 10V10.25H4.25V10C4.25 7.62076 5.32213 5.49194 7.00963 4.07029L4.96967 2.03033C4.67678 1.73744 4.67678 1.26256 4.96967 0.96967Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M4.25 10.25L4.25 15.8304C4.24999 16.3646 4.24998 16.8104 4.27974 17.1747C4.31078 17.5546 4.37789 17.9112 4.54973 18.2485C4.81339 18.7659 5.23408 19.1866 5.75153 19.4503C6.08879 19.6221 6.44545 19.6892 6.82533 19.7203C7.18956 19.75 7.6354 19.75 8.16955 19.75H8.25V22C8.25 22.4142 8.58579 22.75 9 22.75C9.41421 22.75 9.75 22.4142 9.75 22V19.75H14.25V22C14.25 22.4142 14.5858 22.75 15 22.75C15.4142 22.75 15.75 22.4142 15.75 22V19.75H15.8305C16.3646 19.75 16.8104 19.75 17.1747 19.7203C17.5546 19.6892 17.9112 19.6221 18.2485 19.4503C18.7659 19.1866 19.1866 18.7659 19.4503 18.2485C19.6221 17.9112 19.6892 17.5546 19.7203 17.1747C19.75 16.8104 19.75 16.3646 19.75 15.8305V10.25H4.25Z"
				fill="currentColor"
			/>
			<path
				d="M8.25 7C8.25 6.30964 8.80965 5.75 9.5 5.75C10.1904 5.75 10.75 6.30964 10.75 7C10.75 7.69036 10.1904 8.25 9.5 8.25C8.80965 8.25 8.25 7.69036 8.25 7Z"
				fill="currentColor"
			/>
			<path
				d="M13.25 7C13.25 6.30964 13.8096 5.75 14.5 5.75C15.1904 5.75 15.75 6.30964 15.75 7C15.75 7.69036 15.1904 8.25 14.5 8.25C13.8096 8.25 13.25 7.69036 13.25 7Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
